import { useState } from 'react'
import { Upload, X } from 'lucide-react'
import { supabase } from '../supabaseClient'

export default function ImageUploader({ value, onChange, bucket = 'covers' }) {
  const [uploading, setUploading] = useState(false)

  const handleUpload = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    setUploading(true)
    const ext = file.name.split('.').pop()
    const path = `${Date.now()}.${ext}`
    const { error } = await supabase.storage.from(bucket).upload(path, file)
    if (!error) {
      const { data } = supabase.storage.from(bucket).getPublicUrl(path)
      onChange(data.publicUrl)
    }
    setUploading(false)
  }

  return (
    <div>
      {value ? (
        <div className="relative mb-3 w-fit rounded-lg border border-orken-border overflow-hidden">
          <img src={value} alt="Preview" className="h-40 w-auto object-cover" />
          <button type="button" onClick={() => onChange('')} className="absolute top-1 right-1 rounded-full bg-black/60 p-1 text-white hover:bg-black/80">
            <X size={14} />
          </button>
        </div>
      ) : null}
      <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg border border-orken-border bg-orken-bg-2 px-4 py-2 text-sm font-medium text-orken-dim hover:bg-white/5 hover:text-white transition-colors">
        <Upload size={16} />
        {uploading ? 'Enviando…' : value ? 'Trocar imagem' : 'Enviar imagem'}
        <input type="file" accept="image/*" className="hidden" onChange={handleUpload} />
      </label>
    </div>
  )
}
